// extracted by mini-css-extract-plugin
export default {"wrapper":"ResultListToggler_wrapper__dzhKc"};